import { useState } from "react";
import SectionHeading from "@/components/base/SectionHeading";
import { faqList } from "@/mocks/manga";

export default function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section className="bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-3xl px-4 md:px-6">
        <SectionHeading
          eyebrow="追更答疑"
          title="常见问题"
          desc="关于66漫画网更新动态、最新话、补更与断更的常见疑问，这里都有答案。"
        />

        <div className="flex flex-col gap-3">
          {faqList.map((item, i) => {
            const open = openIndex === i;
            return (
              <div
                key={item.q}
                className="overflow-hidden rounded-xl border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : i)}
                  aria-expanded={open}
                  className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left"
                >
                  <span className="text-sm font-bold text-foreground-900 md:text-base">
                    {item.q}
                  </span>
                  <span
                    className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-primary-100 text-primary-700 transition-transform duration-300 ${
                      open ? "rotate-45" : ""
                    }`}
                  >
                    <i className="ri-add-line"></i>
                  </span>
                </button>
                {open && (
                  <div className="border-t border-background-200 px-5 py-4">
                    <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}